import {useCallback} from "react"
import {useQuery, useQueryClient} from "@tanstack/react-query"
import {enrollmentTargetService} from "services"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import {Measurement} from "types/enrollment-target"

const queryCacheKey = "all-admission-measurements"
const INITIAL_DATA: Measurement[] = []

export const useAllAdmissionMeasurements = () => {
    const queryClient = useQueryClient()

    const query = useQuery(
        [queryCacheKey],
        async () => {
            const {data} = await enrollmentTargetService.listMeasurements({
                range: {
                    page: 1,
                    pageSize: UNLIMITED_PAGE_SIZE
                }
            })
            return data
        },
        {
            refetchOnMount: false
        }
    )
    return {
        admissionMeasurements: query.data ?? INITIAL_DATA,
        invalidateAdmissionMeasurementsCache: useCallback(() => {
            queryClient.invalidateQueries({queryKey: [queryCacheKey]})
        }, [queryClient])
    }
}
